import { Component, OnChanges, OnInit, inject, input, model, output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';

import { FormlyService } from '../../services/component-services/formly.service';
import { FormService } from '../../services/component-services/form.service';
import { SystemEnvironmentService } from '../../services/system-environment.service';

@Component({
  selector: 'app-base-inline-form',
  templateUrl: './base-inline-form.component.html',
  styleUrl: './base-inline-form.component.scss',
  imports: [FormlyModule],
})
export class BaseInlineFormComponent implements OnInit, OnChanges {
  private readonly formService = inject(FormService);
  private readonly formlyService = inject(FormlyService);
  private readonly title = inject(Title);
  private readonly systemEnvironmentService = inject(SystemEnvironmentService);

  public readonly header = input<string>();
  public readonly fields = input<FormlyFieldConfig[]>([]);
  public readonly model = model<any>({});
  public readonly smallHeader = input('');
  public readonly submitText = input('');
  public readonly submitIcon = input('');
  public readonly labelsVertical = input(false);
  public readonly fieldsVertical = input(false);
  public readonly searchIsFirst = input(true);
  public readonly leftHeader = input(false);
  public readonly fullWidth = input(false);
  public readonly marginBottom = input(true);
  public readonly marginHeaderTop = input(true);
  public readonly modelUpdated = output<any>();
  public readonly submitted = output<any>();

  public form: UntypedFormGroup = new UntypedFormGroup({});
  protected options: FormlyFormOptions = {};
  protected inlineFields: FormlyFieldConfig[];

  ngOnInit() {
    if (this.header()) {
      this.title.setTitle(this.systemEnvironmentService.pageTitle(this.header()));
    }
  }

  ngOnChanges() {
    if (!this.fields()) {
      return;
    }

    const fields = [...this.fields()];
    if (this.submitText()) {
      fields.push(
        this.formlyService.button(this.submitText(), () => this.onSubmit(), {
          btnClass: 'primary',
          iconClass: this.submitIcon() ? `fa fa-${this.submitIcon()}` : undefined,
        }),
      );
    }

    fields.forEach((field: FormlyFieldConfig) => {
      field.wrappers = ['inline'];
      if (!this.labelsVertical() && field.props) {
        field.props.horizontal = true;
      }
      return field;
    });

    this.inlineFields = fields;
  }

  onSubmit() {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      this.formService.scrollToFirstInvalidField();
      return;
    }

    this.submitted.emit(this.model());
  }

  update() {
    this.updateModel({});
  }

  updateModel(model: any, markUpdated = false, markUnchanged = false) {
    this.model.set({ ...this.model(), ...model });
    this.modelUpdated.emit(this.model());
    if (markUpdated) {
      this.form.markAsDirty();
      this.form.markAllAsTouched();
    }
    if (markUnchanged) {
      this.form.markAsPristine();
      this.form.markAsUntouched();
    }
  }
}
